var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaginationRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "#6E7882",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.31258 15.5L7.41675 14.6042L11.5417 10.4792L7.41675 6.35418L8.31258 5.45834L13.3334 10.4792L8.31258 15.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationRight);
export default __webpack_public_path__ + "static/media/paginationRight.643b17cc803310f2bab5a70c2d3d8f4e.svg";
export { ForwardRef as ReactComponent };